import Button from 'react-bootstrap/Button';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';

const ScrollToTopButton = ({ querySelector }: { querySelector: string }) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const el = document.querySelector(querySelector) as HTMLElement | null;
    setContainer(el);

    if (_.isNil(el)) return undefined;

    const handleScroll = () => {
      setShowButton(el.scrollTop > 500);
    };

    el.addEventListener('scroll', handleScroll);

    return () => el.removeEventListener('scroll', handleScroll);
  }, [querySelector]);

  const scrollToTop = () => {
    if (container) {
      container.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <>
      { showButton && (
        <Button
          size="sm"
          variant='primary'
          onClick={scrollToTop}
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "999px",
            position: 'absolute',
            bottom: "15px",
            right: "20px",
            display: 'flex',
            justifyContent: "center",
            alignItems: 'center',
            cursor: 'pointer'
          }}
        >
          <i className="fas fa-chevron-up text-white" />
        </Button>
      ) }
    </>
  );
};

export default ScrollToTopButton;
